var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item"},[(_vm.loading)?_c('SkeletonBox',{attrs:{"width":"100%"}}):_vm._e(),(!_vm.loading)?[_c('span',{staticClass:"float-right"},[_vm._t("default")],2),_vm._v(" "+_vm._s(_vm.title)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }